import { Maybe } from '@sso/common-types';

export function formatSubstring(baseString: string, textToFormat: Record<string, Maybe<string | JSX.Element>>) {
  const baseStringArray = baseString.split(/{(.*?)}/).filter(Boolean);
  const finalString = [];

  for (let i = 0; i < baseStringArray.length; i++) {
    const text = baseStringArray[i] ?? '';
    if (textToFormat[text] != null) {
      finalString[i] = textToFormat[text] ?? '';
    } else {
      finalString[i] = text;
    }
  }
  return finalString;
}
